"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataType = void 0;

var _ = require("lodash");

var calldata_1 = require("../calldata/calldata");

var raw_calldata_1 = require("../calldata/raw_calldata");

var constants_1 = require("../utils/constants");

var DataType = /*#__PURE__*/function () {
  function DataType(dataItem, factory) {
    _classCallCheck(this, DataType);

    this._dataItem = dataItem;
    this._factory = factory;
  }

  _createClass(DataType, [{
    key: "getDataItem",
    value: function getDataItem() {
      return this._dataItem;
    }
  }, {
    key: "getFactory",
    value: function getFactory() {
      return this._factory;
    }
  }, {
    key: "encode",
    value: function encode(value, rules, selector) {
      var rules_ = Object.assign(Object.assign({}, constants_1.constants.DEFAULT_ENCODING_RULES), rules);
      var calldata = new calldata_1.Calldata(rules_);

      if (selector !== undefined) {
        calldata.setSelector(selector);
      }

      var block = this.generateCalldataBlock(value);
      calldata.setRoot(block);
      var encodedCalldata = calldata.toString();
      return encodedCalldata;
    }
  }, {
    key: "decode",
    value: function decode(calldata, rules, selector) {
      if (selector !== undefined && !_.startsWith(calldata, selector)) {
        throw new Error("Tried to decode calldata, but it was missing the function selector. Expected prefix '".concat(selector, "'. Got '").concat(calldata, "'."));
      }

      var hasSelector = selector !== undefined;
      var rawCalldata = new raw_calldata_1.RawCalldata(calldata, hasSelector);
      var rules_ = Object.assign(Object.assign({}, constants_1.constants.DEFAULT_DECODING_RULES), rules);
      var value = rules_.isStrictMode || rawCalldata.getSizeInBytes() > 0 ? this.generateValue(rawCalldata, rules_) : this.getDefaultValue(rules_);
      return value;
    }
  }, {
    key: "decodeAsArray",
    value: function decodeAsArray(returndata, rules) {
      var value = this.decode(returndata, rules);
      var valuesAsArray = _.isObject(value) ? _.values(value) : [value];
      return valuesAsArray;
    }
  }, {
    key: "getSignature",
    value: function getSignature(isDetailed) {
      if (_.isEmpty(this._dataItem.name) || !isDetailed) {
        return this.getSignatureType();
      }

      var name = this.getDataItem().name;
      var lastIndexOfScopeDelimiter = name.lastIndexOf('.');
      var isScopedName = lastIndexOfScopeDelimiter !== undefined && lastIndexOfScopeDelimiter > 0;
      var shortName = isScopedName ? name.substr(lastIndexOfScopeDelimiter + 1) : name;
      var detailedSignature = "".concat(shortName, " ").concat(this.getSignatureType());
      return detailedSignature;
    }
  }]);

  return DataType;
}();

exports.DataType = DataType;